// extracted by mini-css-extract-plugin
export var editButton = "_nj-0";